// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5011":"b07ecfb8","8417":"daa23756","9393":"00bfb79f"}[chunkId] + ".chunk.css";
};